import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact">
      <div className="contact-container">
        <section className="contact-hero">
          <h1>Contact Us</h1>
          <p>We'd love to hear from you!</p>
        </section>

        <div className="contact-content">
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon">📍</div>
              <h3>Location</h3>
              <p>1116 St James Ave</p>
              <p>Springfield, MA 01104</p>
            </div>

            <div className="info-card">
              <div className="info-icon">📞</div>
              <h3>Phone</h3>
              <p>
                <a href="tel:4134177982" className="contact-link">
                  (413) 417-7982
                </a>
              </p>
            </div>

            <div className="info-card">
              <div className="info-icon">🌐</div>
              <h3>Follow Us</h3>
              <div className="social-contact">
                <a 
                  href="https://www.facebook.com/chestersshamrock" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-contact-link"
                >
                  Facebook
                </a>
                <a 
                  href="https://www.instagram.com/chestersshamrock" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-contact-link"
                >
                  Instagram
                </a>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">🚚</div>
              <h3>Delivery Partners</h3>
              <div className="delivery-info">
                <span className="delivery-tag">DoorDash</span>
                <span className="delivery-tag">Uber Eats</span>
                <span className="delivery-tag">Grubhub</span>
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <h2>Send us a Message</h2>
            <form className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input type="text" id="name" name="name" required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" name="email" required />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone (Optional)</label>
                <input type="tel" id="phone" name="phone" />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea id="message" name="message" rows="5" required></textarea>
              </div>
              <button type="submit" className="submit-button">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;

